export const AFFILIATE_PC_REGISTER_PATH = "/register";
export const AFFILIATE_USER_CENTER_REGISTER_PATH = "/user-center/register";
export const AFFILIATE_H5_REGISTER_PATH = "/h5/pages/loginSon/reg";

function firstValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

export function normalizeAffiliateInviteCode(value) {
  return String(firstValue(value) || "").trim();
}

export function extractAffiliateInviteCode(value) {
  const link = String(value || "").trim();
  if (!link) return "";

  try {
    return normalizeAffiliateInviteCode(
      new URL(link, "https://affiliate.local").searchParams.get("inviteCode"),
    );
  }
  catch {
    return "";
  }
}

export function resolveAffiliateInviteCode(inviteCode, inviteLink) {
  return normalizeAffiliateInviteCode(inviteCode)
    || extractAffiliateInviteCode(inviteLink);
}

export function buildAffiliatePcRegisterUrl(origin, inviteCode, inviteLink = "") {
  const code = resolveAffiliateInviteCode(inviteCode, inviteLink);
  const normalizedOrigin = String(origin || "").trim().replace(/\/$/, "");
  const relativeTarget = code
    ? `${AFFILIATE_PC_REGISTER_PATH}?inviteCode=${encodeURIComponent(code)}`
    : AFFILIATE_PC_REGISTER_PATH;

  if (!normalizedOrigin) return relativeTarget;

  try {
    const target = new URL(AFFILIATE_PC_REGISTER_PATH, `${normalizedOrigin}/`);
    if (!/^https?:$/.test(target.protocol)) return relativeTarget;
    if (code) target.searchParams.set("inviteCode", code);
    return target.toString();
  }
  catch {
    return relativeTarget;
  }
}

export function buildAffiliateH5RegisterUrl(h5SiteUrl, inviteCode) {
  const siteUrl = String(h5SiteUrl || "").trim();
  if (!siteUrl) return "";

  try {
    const target = new URL(
      /^[a-z][a-z\d+.-]*:\/\//i.test(siteUrl) ? siteUrl : `https://${siteUrl}`,
    );
    if (!/^https?:$/.test(target.protocol)) return "";
    target.pathname = AFFILIATE_H5_REGISTER_PATH;
    target.search = "";
    target.hash = "";
    const code = normalizeAffiliateInviteCode(inviteCode);
    if (code) target.searchParams.set("inviteCode", code);
    return target.toString();
  }
  catch {
    return "";
  }
}

export function isAffiliateRegisterPath(path) {
  const normalizedPath = String(path || "").replace(/\/+$/, "") || "/";
  return normalizedPath === AFFILIATE_PC_REGISTER_PATH
    || normalizedPath === AFFILIATE_USER_CENTER_REGISTER_PATH;
}
